import { styled } from "@mui/material/styles"
import { Chip } from "@mui/material"

export const Badge = styled(Chip)(({ theme, color }) => ({
  backgroundColor: color && color !== "default" ? theme.palette[color]["1"] : theme.palette.primary["1"],
  color: color && color !== "default" ? theme.palette[color].main : theme.palette.primary.main,
  fontSize: "1rem",
  height: "24px",

  "& span": {
    padding: "0 8px"
  },

  "&:hover": {
    backgroundColor: color && color !== "default" ? theme.palette[color]["2"] : theme.palette.primary["2"],
    boxShadow: "none"
  }
}))

Badge.defaultProps = {
  color: "primary"
}
